import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ResetButton } from 'shared/components/buttons/ResetButton';
import { useGlobalTheme } from 'shared/utils/useGlobalTheme';

import { ColorInputPanel } from '../../../../../../components/controlledPanels/ColorInputPanel/ColorInputPanel';
import { FormControl } from '../../../../../../components/controlledPanels/FormControl/FormControl';
import type { TooltipConfigProps } from '../TooltipConfig';

export function Background(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, onUpdateStyle } = props;
  const { t } = useTranslation('components.theme.settings');
  const theme = useGlobalTheme();

  const setColor = useCallback((newColor: string) => onUpdateStyle({ backgroundColor: newColor }), [onUpdateStyle]);

  return (
    <FormControl title={t('background')}>
      <ColorInputPanel
        label={t('color')}
        color={styles.backgroundColor ?? theme.other.colors.neutral.white}
        setColor={setColor}
        ResetButton={styles.backgroundColor && <ResetButton onClick={() => onRemoveStyle('backgroundColor')} />}
      />
    </FormControl>
  );
}
